import "./apartments-slider";
import "./omgeving-slider";
import "./filter-categories";
import "./booking-pinpoints";
import "./append-search-params";
// import "./booking-on-single";
import "./change-booking-form-language";
